import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  // Bootstrap by asking the server who we are. /auth/whoami covers both
  // the SSO cookie session and the local JWT cookie (get_current_user is
  // dual-path on the server). One round-trip works for either auth mode.
  useEffect(() => {
    let cancelled = false;
    API.get('/auth/whoami')
      .then(res => { if (!cancelled) setUser(res.data); })
      .catch(() => { if (!cancelled) setUser(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const login = async (email, password) => {
    const res = await API.post('/auth/login', { email, password });
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    // Clear whichever session cookie is present. Both endpoints are
    // idempotent server-side, so calling both is safe; this avoids
    // having to branch on authMethod.
    try { await API.post('/auth/logout'); } catch { /* ignore */ }
    try { await API.post('/auth/session/logout'); } catch { /* ignore */ }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
